import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./futuresubnav.css"


const futuresubNav = ( { }) => {

    
    
    return (
        <section className="subnav" id="subNav">
            <div className="containfix">
                <a className="subNavButton" href="https://fedscoop.com/events/snglive/future-of-government-june/#About">ABOUT</a>
                <a className="subNavButton" href="https://fedscoop.com/events/snglive/future-of-government-june/#Speakers">SPEAKERS</a>
                <a className="subNavButton" href="https://fedscoop.com/events/snglive/future-of-government-june/wrap-up" target="_blank">WRAP-UP</a>
            </div>
         </section>
    )
}

export default futuresubNav